export const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      width: "30%",
    },
  ];
  export const formatData = (data) => {
    return {
      id: data.id,
      nombre: data.nombre,
    };
  };
  
  export const camposFormulario = {
    title: "Tipo Imagen",
    campos: [
      {
        name: "id",
        label: "id",
        type: "number",
        hidden: true,
      },
      {
        name: "nombre",
        label: "Nombre del Tipo Imagen",
        type: "text",
        rules: [
          {
            required: true,
            max: 45,
            min: 1,
          },
        ],
      },
    ],
  };
  export const camposFilter = {
    title: "Tipo Imagen",
    campos: [
      {
        name: "nombre",
        type: "text",
        placeholder: "Nombre del Tipo Imagen",
        rules: [
          {
            max: 45,
          },
        ],
      },
    ],
  };
  